<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
    <a-modal title="对公转账审核" :width="1000" :open="true" :confirmLoading="state.loading" :maskClosable="false"
        @ok="onFormSubmit" @cancel="cancel">
        <template #footer>
            <a-button @click="cancel">取消</a-button>
            <a-popconfirm title="是否确定？" @confirm="onFormSubmit">
                <a-button type="primary" :loading="state.submitLoading">确定</a-button>
            </a-popconfirm>
        </template>
        <a-skeleton :loading="state.loading" active :paragraph="{ rows: 6 }">
            <a-form ref="ruleForm" :model="formState" v-bind="formLayout">
                <a-form-item label="提交人姓名">
                    {{ props.detailData.submit_operator_admin_info.nickname ?
                        props.detailData.submit_operator_admin_info.nickname : '--' }} ； 付款金额：{{ props.detailData.money ?
                        props.detailData.money : '--' }} ；类型：<span v-if="props.detailData.buss_type == 3">刻章-对公转账</span>
                    <span v-if="props.detailData.buss_type == 2">地址-对公转账</span>
                </a-form-item>
                <a-form-item label="付款备注：" v-if="props.detailData.remark">{{ props.detailData.remark }}</a-form-item>
                <a-form-item label="其他收入：" v-if="props.detailData.other_name"> {{
                    props.detailData.other_name }}
                    【{{
                        props.detailData.other_amount }}】
                </a-form-item>
                <a-form-item label="附件：">
                    <div v-if="props.detailData.attachment">
                        <span v-for="(item, index) in props.detailData.attachment">
                            <a-image
                                v-if="item.name.indexOf('jpg') > -1 || item.name.indexOf('png') > -1 || item.name.indexOf('jpeg') > -1"
                                :key="index" :width="120" :height="50" :src="$store.state.user.image_domain + item.url">
                            </a-image>
                            <p v-else>
                                <a :href="$store.state.user.image_domain + item.url" target="_blank">{{ item.name
                                }}</a>
                            </p>
                        </span>
                    </div>

                </a-form-item>

                <a-form-item label="公司名称">
                    <div v-for="item in props.detailData.buss_list">{{ item.full_name }} ￥{{ item.money }}元</div>
                    <span v-if="props.detailData.payment_type == 1">【支付注册费】</span>
                    <span v-if="props.detailData.payment_type == 2">【地址续费】</span>
                    <span v-if="props.detailData.payment_type == 3">【其他收入】</span>
                    <!-- 新增总计行 -->
                    <div style="font-weight: bold; margin-top: 4px;">
                        总计：￥{{props.detailData.buss_list.reduce((sum, cur) => sum + Number(cur.money), 0)}}元
                    </div>
                </a-form-item>
                <div v-if="props.detailData.buss_type == 2">
                    <a-form-item label="收费类型">
                        <span v-if="props.detailData.fee_standard == 1">按年续费</span>
                        <span v-if="props.detailData.fee_standard == 2">一次性</span><span> ；续费时长：{{
                            props.detailData.month_amount }}
                            月</span>
                    </a-form-item>
                </div>
                <a-form-item label="审核结果" :required="true">
                    <a-radio-group v-model:value="formState.status" button-style="solid">
                        <a-radio :value="1">通过</a-radio>
                        <a-radio :value="2">不通过</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item label="付款金额" v-if="formState.status == 1">
                    <a-input v-model:value="formState.money" placeholder="请输入转账金额" addonAfter="元" style="width: 150px">
                    </a-input>如果改金额，则会算到最后一个
                </a-form-item>
                <a-form-item label="备注">
                    <a-textarea v-model:value="formState.remark" placeholder="请输入备注" style="width: 400px"></a-textarea>
                </a-form-item>
            </a-form>
        </a-skeleton>
    </a-modal>
</template>
<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, computed, handleError } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import type { PaginationProps } from 'ant-design-vue'
import { useStore } from 'vuex'
const $store = useStore()
const emit = defineEmits(['ok', 'cancel'])
const props = defineProps({
    detailData: {
        type: Object,
        default: () => { }
    }
})
const formLayout = {
    labelCol: {
        xs: { span: 4 },
        sm: { span: 4 }
    },
    wrapperCol: {
        xs: { span: 16 },
        sm: { span: 16 }
    }
}
interface state {
    loading: boolean
    submitLoading: boolean
}
const state = reactive<state>({
    loading: false,
    submitLoading: false,
})
interface FormStateIface {
    id: number
    status: number
    money: number
    remark: string
}
const formState = reactive<FormStateIface>({
    id: 0,
    status: 1,
    money: 0,
    remark: ''
})
onMounted(() => {
    //直接显示props
    formState.id = props.detailData.id
    formState.money = props.detailData.money
})
const onFormSubmit = () => {
    if (formState.money <= 0) {
        message.error('请输入金额')
        return
    }
    state.submitLoading = true
    let requestParam = {
        url: '/admin/v1/publicARecharge/audit',
        method: 'post',
        data: formState
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg)
            emit('ok')
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
        .finally(() => {
            state.submitLoading = false
        })
}
const cancel = () => {
    emit('cancel')
}
</script>
